import LayoutMobile from "../Layout/LayoutMobile";

export default (window) => {
    new LayoutMobile(window).boot();
};
